import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, Center, Spinner } from '@chakra-ui/react';
import { system } from '@/theme';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { AuthProvider, useAuth } from './features/auth/authContext';
import { queryClient } from './lib/queryClient';
import { router } from './router';

/**
 * Firebase Auth の onAuthStateChanged は非同期解決されるため、
 * auth.isLoading が false になるまで RouterProvider を描画しない。
 * これにより `_authenticated.tsx` の beforeLoad ガードが
 * 未確定 state で誤作動するのを防ぐ。
 */
function AppRouter() {
  const auth = useAuth();

  if (auth.isLoading) {
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  return <RouterProvider router={router} context={{ auth, queryClient }} />;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ChakraProvider value={system}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </QueryClientProvider>
    </ChakraProvider>
  </React.StrictMode>
);
